<template>
  <v-container class="fill-height">
    <v-row class="fill-height" justify="center" align="center" align-content="center">
      <v-col cols="12" v-if="isLoading">
        <div class="text-center">
          <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>
      </v-col>
      <v-col cols="12" v-if="isLoading">
        <div v-html="loadingMessage"></div>
      </v-col>
      <v-col cols="12" v-if="!isLoading">
        <div v-html="messageOnScreen"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'OfferRejectPage',
    components: {
      //
    },
    props: {
      //
    },
    async mounted() {
      if (this.$route.params.identicalHash) {
        this.identicalHashIsValid = await this.callOfferRejection(this.$route.params.identicalHash);
        setTimeout(this.loadingFinished, 2200);
      } else {
        this.$router.push({name: 'home'});
      }
    },
    data() {
      return {
        isLoading: true,
        identicalHashIsValid: false,
        messageOnScreen: '<div class="display-1 text-center">Az ajánlat elutasítása folyamatban...</div>',
        loadingMessage: '<div class="display-1 text-center">Az ajánlat elutasítása folyamatban...</div>',
        successMessage: '<div class="display-2 text-center mb-6"><b>Ajánlat elutasítva!</b></div>'
          + '<div class="headline text-center mb-4">Sajnáljuk, hogy ajánlatunk nem volt számodra megfelelő.<br>'
          + 'Ezzel kapcsolatos véleményed szívesen fogadjuk az info@tmx.hu e-mail címen!</div>'
          + '<div class="text-center">Köszönjük</div>',
        errorMessage: '<div class="display-2 text-center mb-6"><b>Az ajánlat elutasítása során hiba lépett fel!</b></div>'
          + '<div class="headline text-center mb-4">Kérjük próbáld meg újra, vagy fordulj hozzánk bizalommal az <br>'
          + 'info@tmx.hu e-mail címen.</div>'
          + '<div class="text-center">Türelmed köszönjük!</div>',
      };
    },
    methods: {
      async callOfferRejection(hash) {
        const response = await this.$store.dispatch('offerRejection', hash);
        if (response === 200) {
          this.messageOnScreen = this.successMessage;
          return true;
        } else {
          this.messageOnScreen = this.errorMessage;
        }
        return false;
      },
      loadingFinished() {
        this.isLoading = false;
      }
    },
  };
</script>

<style scoped>

</style>
